export async function copyText(text: string): Promise<boolean> {
  const desktop = (window as any).vorbelloDesktop;
  if (desktop?.isDesktop && typeof desktop.copyInvitationText === 'function') {
    try { if (await desktop.copyInvitationText(text)) return true; } catch {}
  }
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch { /* Fall back to the document's copy command. */ }
  const input = document.createElement('textarea');
  input.value = text;
  input.setAttribute('readonly', '');
  input.style.cssText = 'position:fixed;left:-10000px;top:0;opacity:0';
  document.body.appendChild(input);
  input.select();
  try { return document.execCommand('copy'); }
  catch { return false; }
  finally { input.remove(); }
}
